import { render } from "./Panoramic.vue?vue&type=template&id=44d5278b&ts=true"
import script from "./Panoramic.vue?vue&type=script&lang=ts"
export * from "./Panoramic.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\封面新闻\\activity\\ssccloudtour\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__